import React, { Component } from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';

export default class NoCoverageModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribing: false,
    };
  }

  render() {
    return (
      <div className={this.props.className}>
        <Spin spinning={this.state.subscribing}>
          <div className="title">Sorry, we don&#39;t cover your area just yet.</div>
          <div className="content">
            We&apos;re constantly growing our coverage area. If you have any questions, please email{' '}
            <a href="mailto:support@fixter.co.uk">support@fixter.co.uk</a>.
          </div>
        </Spin>
      </div>
    );
  }
}

NoCoverageModalContent.propTypes = {
  className: PropTypes.string,
};

NoCoverageModalContent.defaultProps = {
  className: '',
};
